import type { CarrierProps } from '@/components/FlightSummary/Carrier/types';
import type { CommercialBrand } from '@/generated/graphql';

export function getDisplayedCarriers(
  carriers: CarrierProps['carriers'],
  commercialBrands: CarrierProps['commercialBrands'],
  withCommercialBrand: CarrierProps['withCommercialBrand']
): CommercialBrand[] {
  const hasCommercialBrands =
    Array.isArray(commercialBrands) && commercialBrands.length > 0;
  const allBrandsNotNull =
    hasCommercialBrands && commercialBrands.every((brand) => brand != null);

  const showCommercialBrand =
    withCommercialBrand && hasCommercialBrands && allBrandsNotNull;
  const displayedCarriers = showCommercialBrand ? commercialBrands : carriers;

  const carriersToDisplay: CommercialBrand[] = [];
  displayedCarriers.forEach((carrier) => {
    if (carrier) {
      carriersToDisplay.push(carrier);
    }
  });
  return carriersToDisplay;
}
